<template>
  <div v-if="showNavigation" class="mb-5 navigation main-navigation">
    <div v-if="$store.state.loading" class="page-loading">
      <div class="page-loading-bar"></div>
    </div>
    <div class="fixed-forgrid">
      <div class="top-banner">
        <b-link v-if="logoUrl !== undefined" :to="navLinkPrefix + logo.link" class="home-logo">
          <img :src="host + logoUrl" :alt="logo.name">
        </b-link>
        <b-link :to="'/ads/show/7.html'" target="_blank" class="home-banner">
          <img :src="host + '/ads/show/7.png'" alt="Banner">
        </b-link>
      </div>
    </div>
    <b-navbar class="navbar-expand home-navigation" :class="$route.params.ln === 'kz' ? 'kz-nav-item' : ''">
      <b-collapse is-nav id="nav_dropdown_collapse">
        <b-navbar-nav  class="navigation-content home-right-nav fixed-forgrid">
          <b-nav-item
            v-for="(link, index) in navigationLinks"
            :key="index"
            :to="link.url.includes('http', 0) ? '' : navLinkPrefix + link.url"
            :href="link.url.includes('http', 0) ? link.url : ''"
            :class="[routePath === link.url || link.childList.some(m => routePath.includes(m.url)) ? 'active' : '']"
            :target="link.target"
            class="home-nav-item">
            {{ link.title }} <i v-if="link.childList.length > 0" :class="'fas fa-sort-down'"></i>
            <div v-if="link.childList.length > 0" class="dropdown-subnav">
              <b-list-group class="subnav-list-group">
                <!-- <b-list-group-item
                  :to="link.url.includes('http', 0) ? '' : navLinkPrefix + link.url"
                  :href="link.url.includes('http', 0) ? link.url : ''"
                  :class="[routePath === link.url || link.childList.some(m => routePath.includes(m.url)) ? 'active' : '']"
                  :target="link.target"
                  class="subnav-item parent-link active">
                  {{ link.title }} <i v-if="link.childList.length > 0" :class="'fas fa-sort-down'"></i>
                </b-list-group-item> -->
                <b-list-group-item
                  v-for="(subLink, subIndex) in link.childList"
                  :key="subIndex"
                  :target="subLink.target"
                  :class="[routePath.includes(subLink.url) ? 'active' : '']"
                  :to="routePath.includes(subLink.url) ? '' : navLinkPrefix + subLink.url"
                  class="subnav-item">
                  {{ subLink.title }}
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-nav-item>
          <li class="nav-item search-nav-item ml-auto">
            <span class="nav-link">
              <i class="fas fa-search"></i>
              <div class="search-form">
                <div class="input-group input-group-md">
                  <input
                    @keyup.13="searchNews"
                    v-model="keyWord"
                    type="text"
                    class="form-control"
                    :placeholder="ls_search"
                    aria-describedby="addon">
                  <div class="input-group-prepend">
                    <b-btn variant="info" @click="searchNews"><i class="fas fa-search"></i></b-btn>
                  </div>
                </div>
              </div>
            </span>
          </li>
          <li class="nav-item top-devider"></li>
          <b-nav-item class="language-icon">
            <i class="fas fa-globe"></i>
          </b-nav-item>
          <select-language></select-language>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import SelectLanguage from "../SelectLanguage.vue";
import printQL from "@/assets/js/org.js";

export default {
  data() {
    return {
      keyWord: "",
      showNavigation: true,
      logo: {
        name: "QazLatyn",
        link: "/home"
      }
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    logoUrl() {
      return this.$store.state.siteSettings.pcLogo;
    },
    navigationLinks() {
      return this.$store.state.navigationList;
    },
    navLinkPrefix() {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln
        : "";
    },

    ls_search() {
      return this.$store.state.languagePack.ls_search;
    },

    routePath() {
      return this.$route.params.ln !== undefined
        ? this.$route.path.substring(
            this.$route.path.substring(1).indexOf("/") + 1
          )
        : this.$route.path;
    }
  },

  methods: {
    searchNews() {
      if (this.keyWord.trim()) {
        this.$router.push({
          path: "article",
          query: {
            keyWord: this.keyWord
          }
        });
      }
    },

    getHomeNavigation() {
      this.showNavigation = false;
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("typeId", 3);
      this.$http
        .post(this.host + "/api/qazlatyn/getnavigationlist", fd)
        .then(result => {
          this.showNavigation = true;
          if (result.status === 200) {
            this.$store.state.navigationList = result.body.data;
          } else {
            // console.log('Err');
          }
        });
    }
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getHomeNavigation();
      }
    }
  },

  created() {
    this.getHomeNavigation();
  },

  mounted() {
    printQL();
  },

  components: {
    "select-language": SelectLanguage
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/common.scss";
.main-navigation {
  position: relative;

  .page-loading {
    position: absolute;
    top: 123px;
    left: 0;
    right: 0;
  }
}
.navigation {
  .top-banner {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1rem;
    height: 4.5rem;

    .home-logo {
      display: inline-block;
      img {
        height: 2.5rem;
      }
    }

    .home-banner {
      img {
        margin-top: -0.25rem;
        height: 3.5rem;
      }
    }
  }

  .home-navigation {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 0.5rem;
    padding-bottom: 0.375rem;
    background-color: #008496;

    .navigation-content {
      padding-left: 0;
      padding-right: 0;

      .home-nav-item {
        position: relative;
        padding-left: 0.125rem;
        padding-right: 0.125rem;
        white-space: nowrap;

        .nav-link {
          color: #ffffff;
          font-weight: 500;
          font-size: 1rem;
          font-family: Roboto, 'Open Sans', sans-serif;
          padding: 0.375rem 1.1875rem;
          border-radius: 0.25rem;

          &:hover {
            // background-color: #006b75;
            background-color: darken(#008496, 5%);
          }
        }

        &:hover {
          .dropdown-subnav {
            position: absolute;
            top: 29px;
            opacity: 1;
            height: auto;
            z-index: 1001;
          }
        }

        .dropdown-subnav {
          position: absolute;
          top: 0.125rem;
          left: 0;
          opacity: 0;
          width: 100%;
          padding: 0.125rem;
          transition: all 0.3s ease-in-out;
          // font-size: 0.75rem;
          z-index: -1;
          border-bottom-left-radius: 0.25rem !important;
          border-bottom-right-radius: 0.25rem !important;

          .subnav-list-group {
            text-align: center;

            .subnav-item.parent-link {
              font-size: 1rem;
            }

            .subnav-item {
              border: #006b75;
              border-radius: 0;
              background-color: darken(#008496, 5%);
              padding: 0.375rem 0.5rem;
              color: #ffffff;

              &:last-child {
                border-bottom-left-radius: 0.25rem;
                border-bottom-right-radius: 0.25rem;
              }

              &:hover {
                background-color: #006b75;
              }
            }

            .active {
              background-color: #006b75;
            }
          }
        }
      }

      .search-nav-item {
        position: relative;
        border-radius: 0.25rem;
        transition: all 1s ease-in-out;

        &:hover {
          // background-color: #006b75;

          .nav-link {
            color: #ededed !important;
          }

          .search-form {
            opacity: 1;
            box-shadow: 0 0 0.5rem #013036;
            width: 20rem;
          }
        }

        .search-form {
          position: absolute;
          top: 0;
          right: -0.25rem;
          border-radius: 0.25rem;
          width: 5rem;
          opacity: 0;
          box-shadow: 0 0 0 #01303600;
          transition: all 0.5s ease-in-out;

          .form-control:focus {
            box-shadow: none;
            border-color: #008496;
          }

          .btn-info {
            background-color: #008496;
            border-color: #008496;
          }
        }
      }

      .active {
        .nav-link {
          background-color: #006b75;
        }
      }

      .dropdwon {
        .nav-link {
          color: #ffffff !important;
        }
      }
    }
  }

  .home-right-nav {
    .nav-item > a {
      color: #ffffff;
    }
    .nav-item .nav-link {
      color: #ffffff !important;
    }

    .top-devider {
      margin-top: 4px;
      margin-right: 0.75rem;
      margin-left: 1.625rem;
      height: 1.675rem;
      border-left: 1px solid #ced4da;
    }
  }
}
/* RTL */
.rtl-layout {

  .home-right-nav,
  .top-banner {
    direction: rtl;
  }

  .search-nav-item {
    margin-right: auto !important;
    margin-left: 0 !important;

    .search-form {
      right: -45px !important;

      .input-group {
        input {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
          border-top-right-radius: 3px !important;
          border-bottom-right-radius: 3px !important;
        }

        .input-group-prepend button {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
          border-top-left-radius: 3px !important;
          border-bottom-left-radius: 3px !important;
        }
      }
    }

    &:hover {
      .search-form {
        right: -18rem !important;
      }
    }
  }
}
</style>

<style>
.kz-nav-item .nav-link {
  font-size: 14px !important;
}
.navbar-light .home-right-nav .nav-link {
  color: #ffffff !important;
}
.navbar-light .home-right-nav .nav-link:hover {
  color: #f0f0f0 !important;
}
.navbar-light .navbar-nav .show > .nav-link {
  color: #f0f0f0 !important;
}
</style>
